// Floating WhatsApp support button — visible on every page (public + logged).
// Number and message are hard-coded per business requirement.
import { useLocation } from "react-router-dom";

const WA_NUMBER = "5519981551221";
const WA_TEXT = "Olá, preciso de suporte para criar minha vps.";

export default function WhatsAppButton() {
  const location = useLocation();
  // Hide on admin routes — admin has other support channels
  if (location.pathname.startsWith("/admin")) return null;

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Suporte via WhatsApp"
      data-testid="whatsapp-support-btn"
      className="fixed bottom-5 right-5 z-50 group"
    >
      {/* pulsing halo */}
      <span className="absolute inset-0 rounded-full bg-emerald-400 opacity-40 animate-ping" style={{ animationDuration: "2.4s" }} />
      <span className="relative flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] transition-colors px-4 py-3 shadow-xl shadow-emerald-500/40 text-white font-medium text-sm">
        {/* WhatsApp SVG (inline, no dep) */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.7c-.29-.15-1.73-.85-2-.95s-.46-.15-.66.15-.75.95-.92 1.15-.34.22-.63.07a8.11 8.11 0 0 1-2.39-1.47 8.94 8.94 0 0 1-1.65-2.06c-.17-.29 0-.45.13-.6s.29-.34.44-.51a1.85 1.85 0 0 0 .29-.49.53.53 0 0 0 0-.51c-.07-.15-.66-1.59-.9-2.17s-.48-.5-.66-.5h-.56a1.08 1.08 0 0 0-.78.37 3.28 3.28 0 0 0-1 2.44 5.7 5.7 0 0 0 1.19 3 13 13 0 0 0 4.95 4.36 16.65 16.65 0 0 0 1.65.61 4 4 0 0 0 1.83.11 3 3 0 0 0 2-1.4 2.47 2.47 0 0 0 .17-1.4c-.07-.15-.26-.22-.55-.37zM16.06 4A12 12 0 0 0 5.58 21.83l-1.5 4.63a1 1 0 0 0 1.24 1.28l4.75-1.44a12 12 0 0 0 6 1.66h.05a12 12 0 0 0-.06-24zm0 21.9a10 10 0 0 1-5-1.36l-.36-.21-3.72 1.13 1.15-3.63-.24-.37a9.94 9.94 0 0 1 8.14-15.44 9.94 9.94 0 0 1 0 19.88z" />
        </svg>
        <span className="hidden sm:inline">Suporte</span>
      </span>
    </a>
  );
}
